module.exports = {
	"opening": [
		{
			"day": "Di",
			"time": "17:30 - 21:30"
		},
		{
			"day": "Lu",
			"time": "Fermé"
		},
		{
			"day": "Ma",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Me",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Je",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Ve",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Sa",
			"time": "17:30 - 21:30"
		}
	],
	"compact": [
		{
			"days": "Lu",
			"time": "Fermé"
		},
		{
			"days": "Ma - Je",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"days": "Ve - Sa",
			"time": "11:30 - 14:00 / 17:30 - 21.30"
		},
		{
			"days": "Di",
			"time": "17:30 - 21:30"
		}
	],
	"special": {
		"from": 0,
		"to": 0,
		"digest": "",
		"name": "",
		"time": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/timetable.json
// module id = 21
// module chunks = 0